import React from "react";
import { Link } from "react-router-dom";
import dummyImg from "../../assets/images/dummyPlaceholder.jpg";

export default function InstructorCardForCourseAssignment({
  courseAssignmentToInstrcutor,
  setCourseAssignmentToInstrcutor,
  data,
}) {
  return (
    <article className="instructors-item mb-25">
      <input
        type="radio"
        checked={courseAssignmentToInstrcutor === data.id}
        name={"instrcutor"}
        id={"instrcutor" + data.id}
        onClick={() => setCourseAssignmentToInstrcutor(data.id)}
      />
      <label htmlFor={"instrcutor" + data.id}>
        <div className="img-holder mb-10">
          <img
            src={
              data?.profile_picture
                ? `${process.env.REACT_APP_GALLERY_URL}/${data.profile_picture}`
                : dummyImg
            }
            alt="Profile"
          />
        </div>
        <h4 className="ah-text-base fw-semibold mb-8 black-900 text-capitalize">
          {data.full_name}
        </h4>
        <p className="ah-text-xs black-400 mb-0">{data.role.name}</p>
      </label>
    </article>
  );
}
